import { Injectable } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Injectable({
  providedIn: 'root'
})
export class FacturacionService {

  constructor(private authService: AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

  get isSeguimientosRefacturacion(): boolean {
    return this.hasRole(
      TipoUsuario.OPERADOR_3,
      TipoUsuario.OPERADORDIRECTO,
      TipoUsuario.SUPERVISOR,
      TipoUsuario.JEFEDEAEROPLANTA,
      TipoUsuario.TUTOR,
      TipoUsuario.RESPRODUCTO
    );
  }

  get isRolesHistorialRefacturacion(): boolean {
    return this.hasRole(
      TipoUsuario.COMERCIAL,
      TipoUsuario.COMERCIAL_LN,
      TipoUsuario.COMERCIAL_AV,
      TipoUsuario.APROBADORBYR,
      TipoUsuario.FACTURACION, 
      TipoUsuario.REFACTURACION,
      TipoUsuario.CONSPRECIOS,
      TipoUsuario.SEGURIDADTABLAS
    );
  }
}
